import React from "react";

import RecentOrdering from "./RecentOrdering";
import RecentBetting from "./RecentBetting";
import DrawResult from "./DrawResult";
import Balance from "../../pages/components/Balance";
import RightBoard from "./RightBoard";
import {useLotto5} from "../../store/lotto5/Lotto5Context";

export default () => {
    const {user: {userBalance}} = useLotto5();
    return <div className="wrap-lotto5-content">
        <div className="row recent-betting-table w-100">
            {/* betting history left side */}
            <div className="col-3 no-padding-div border">
                {/* user balance */}
                <Balance pendingAmount={userBalance.pendingLotto5}/>
                {/* End of user balance */}

                {/* Last drawing */}
                <DrawResult/>
                {/* End of last drawing */}

                {/* Recent Ordering */}
                <RecentOrdering/>
                {/* End of recent ordering */}

                {/* Recent betting */}
                <RecentBetting/>
                {/* End of recent betting */}

            </div>
            {/* end of betting history left side */}

            {/* betting dashboard and pricing */}
            <RightBoard/>
            {/* end of betting dashboard and pricing */}
        </div>


    </div>
}